import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/hub.js';
import Store from 'store/store';
import 'store/bolt/hub';
import { accessNested } from 'utils/utils';

import Hero from 'components/bolt/hub/components/hero/hero';
import Carousel from 'components/bolt/hub/components/carousel/carousel';
import SideButton from 'components/bolt/hub/components/sideButton/sideButton';
import HeroCarousel from 'components/bolt/hub/components/heroCarousel/heroCarousel';

// import s from 'components/bolt/hub/hub.sss';

export default class Hub extends BaseComp.default {
	constructor(props) {
		super(props);
		this.pageId = props?.id;
	}

	componentDidMount() {
		Store.emit('UPDATE_ACTIVE_PERCENTAGE', this.pageId);
	}

	render({ store, id }) {
		const section = accessNested(store, `appData.pages.${id}.section`, '');
		const clientDimensions = accessNested(store, 'client.dimensions', {});
		const heroData = accessNested(store, `appData.pages.${id}.data.hero`, '');
		const fallbackFormat = accessNested(store, `appData.pages.${id}.data.alternativeImageFormat`, 'jpg');
		const sideButtonData = accessNested(store, `appData.pages.${id}.data.sideButton`, '');
		const useTileSlantyTag = accessNested(store, 'appData.options.carouselTilesUseSlantyTags', false);
		const desktopSolidHeader = accessNested(store, 'header.powsterHeader.desktopSolidHeader', false);
		const headerHeight = accessNested(store, 'client.headerHeight', '');
		const hubActivePercentage = accessNested(store, 'hubActivePercentage', null);
		const appData = accessNested(store, `appData.pages.${id}.data`, {});
		const client = accessNested(store, 'client', '');
		return (
			<div style={{ marginTop: (!section && desktopSolidHeader) ? headerHeight : '' }} data-section={id}>
				{this.heroCarousel ? (
					<HeroCarousel
						appData={appData}
						data={this.heroCarousel}
						client={client}
						id={id}
						visible={hubActivePercentage >= 0.15}
						store={store}
					/>
				) : (
					<Hero
						data={heroData}
						clientDimensions={clientDimensions}
						fallbackFormat={fallbackFormat}
						visible={hubActivePercentage >= 0.15}
						hide={hubActivePercentage < 0.15}
						store={store}
					/>
				)}

				{this.carousels.map((carousel, i) => (
					<Carousel
						data={carousel}
						index={i}
						clientDimensions={clientDimensions}
						useTileSlantyTag={useTileSlantyTag}
						key={i}
						fallbackFormat={fallbackFormat}
						isHubCarousel
						id={id}
					/>
				))}
				{sideButtonData && <SideButton data={sideButtonData} />}
				{this.renderBottom()}
			</div>
		);
	}

}